'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/awards-count',
        method: 'GET'
      },
      types: ['GET_EVENTS_AWARDS_COUNT_START', 'GET_EVENTS_AWARDS_COUNT', 'GET_EVENTS_AWARDS_COUNT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getAwardsCountByEventLevel.js
// module id = 229
// module chunks = 0